import React from "react";
import HorizontalTimeline from "react-horizontal-timeline";



export default class Timeline extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            curIdx: 0,
            prevIdx: -1
        };
    }

    //state = { value: 0, previous: 0 };

    render() {
        const { curIdx } = this.state;
        const curStatus = this.props.time[curIdx].evento;
        const curStatusB = this.props.time[curIdx].descripcion;

        return (
            <div className="cd-horizontal-timeline loaded">
                {/* Bounding box for the Timeline */}
                <div
                    className="timeline"
                >
                    <HorizontalTimeline
                        styles={{
                            background: "#dfdfdf",
                            foreground: "#dca117",
                            outline: "#dfdfdf",
                            height: '5px'
                        }}
                        index={this.state.curIdx}
                        indexClick={index => {
                            const curIdx = this.state.curIdx;
                            this.setState({ curIdx: index, prevIdx: curIdx });
                        }}
                        values={this.props.time.map(x => x.fecha)}
                        getLabel={function (date) { return date.slice(0, 4); }}
                        fillingMotion={{ stiffness: 150, damping: 25 }}
                        isOpenBeginning={true}
                        isOpenEnding={false}
                    />
                </div>
                <div className="events-content">

                    <ol>
                        <li className="selected" data-date="01/01/2008">
                            <div className="row">
                                <div className="col-md-8 offset-md-2 text-center">
                                    <h4>{curStatus}</h4>
                                    <p>{curStatusB}</p>
                                </div>
                            </div>
                        </li></ol>
                </div>
            </div>
        );
    }
}
